import { render, staticRenderFns } from "./CustomerMaterialName.vue?vue&type=template&id=efff24cc"
import script from "./CustomerMaterialName.vue?vue&type=script&lang=js"
export * from "./CustomerMaterialName.vue?vue&type=script&lang=js"
import style0 from "./CustomerMaterialName.vue?vue&type=style&index=0&id=efff24cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports